import { getFormattedTimeRange } from '@lmt/unicorn-shared/app/components/patients/common';
import { RPDF, Text, View } from '../common/react-pdf';
import React from 'react';
import { ColorCircle } from '../svg/ColorCircle';
import { ReportVisitInfo } from '../common/types';
import { useTranslation } from 'react-i18next';

interface Props {
  visit: ReportVisitInfo;
  title: string;
  isDark: boolean;
}

export const VisitRow: React.FC<Props> = (props) => {
  const { visit, isDark, title } = props;
  const i18next = useTranslation();
  return (
    <RPDF.View
      wrap={false}
      style={[
        RPDF.styles.rowContainer,
        isDark ? RPDF.styles.darkRowBackground : RPDF.styles.lightRowBackground,
      ]}
    >
      <RPDF.View style={RPDF.tableColumnsStyles.timeColumn}>
        <RPDF.Text style={RPDF.styles.rowText}>
          {getFormattedTimeRange(visit.startDate, visit.endDate)}
        </RPDF.Text>
      </RPDF.View>
      <RPDF.View style={RPDF.tableColumnsStyles.visitTypeColumn}>
        <ColorCircle style={RPDF.styles.rowImage} color={visit.color} />
        <RPDF.Text style={RPDF.styles.visitText}>
          {i18next.t(title as any)}
        </RPDF.Text>
      </RPDF.View>
      <RPDF.View style={RPDF.tableColumnsStyles.patientColumn}>
        <RPDF.Text style={RPDF.styles.rowText}>{visit.patientName}</RPDF.Text>
      </RPDF.View>
      <RPDF.View style={RPDF.tableColumnsStyles.doctorColumn}>
        <RPDF.Text style={RPDF.styles.rowText}>{visit.doctorName}</RPDF.Text>
      </RPDF.View>
    </RPDF.View>
  );
};
